import React, { createContext, useContext, useState } from 'react';

interface InvoiceInProgressContextType {
  invoiceInProgress: boolean;
  setInvoiceInProgress: (inProgress: boolean) => void;
}

const InvoiceInProgressContext = createContext<InvoiceInProgressContextType | undefined>(undefined);

export const useInvoiceInProgress = () => {
  const ctx = useContext(InvoiceInProgressContext);
  if (!ctx) {
    throw new Error('useInvoiceInProgress must be used within an InvoiceInProgressProvider');
  }
  return ctx;
};

export const InvoiceInProgressProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [invoiceInProgress, setInvoiceInProgress] = useState(false);
  return (
    <InvoiceInProgressContext.Provider value={{ invoiceInProgress, setInvoiceInProgress }}>{children}</InvoiceInProgressContext.Provider>
  );
};
